import {
    comMapping
} from '@/components/util/Function/comMapping';

export default {
    pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        paginationkey: 0
    },
    formlist: [
        {
            prop: 'sobName',
            label: '账套名称',
            type: 'input',
            width: '340px'
        },
        {
            prop: 'bsType',
            label: '业务专项',
            type: 'select',
            width: '340px',
            selectval: comMapping.$ywzx
        }
    ],
    requisitionFormList: [
        {
            prop: 'sobName',
            label: '账套名称',
            type: 'input',
            width: '340px'
        },
        {
            prop: 'bsType',
            label: '业务范围',
            type: 'select',
            width: '340px',
            selectval: comMapping.$ywfw
        }
    ],
    formdata: {
        SobName: '',
        bsType: ''
    },
    headData: [
        {
            title: '公司代码',
            prop: 'companyCode',
            width: 110,
            custom: true

        },
        {
            title: '公司名称',
            prop: 'nsrmc',
            width: 130,
            custom: true

        }
    ]
};
